export default {
    init() {
        // JavaScript to be fired on the home page

        // Masthead carousel
        if ($('.slider--home').length > 0) {
            var slider = $('.slider--home'),
                sliderNav = $('.slider-nav');

            slider.slick({
                slide         : '.slider--home .slide',
                autoplay      : false,
                autoplaySpeed : 6000,
                infinite      : true,
                cssEase       : 'ease',
                slidesToShow  : 1,
                slidesToScroll: 1,
                swipeToSlide  : true,
                dots          : false,
                arrows        : false,
                fade          : true,
                speed         : 1000,
                rows          : 0,
                asNavFor      : sliderNav,
                responsive    : [
                    {
                        breakpoint: 992, // max width 768
                        settings: {
                            dots: true,
                        },
                    },
                ],
            });

            sliderNav.slick({
                slide         : '.slider-nav .slider-nav__item',
                slidesToShow  : 4,
                slidesToScroll: 1,
                asNavFor      : slider,
                dots          : false, 
                arrows        : false,
                focusOnSelect: true,
                rows          : 0,
            });
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// /Users/mishatrombley/Documents/Sites/aurora-institute/app/public/wp-content/themes/aurora-institute/resources/assets/scripts/routes/home.js